module.exports = __webpack_public_path__ + "img/soft_11.dc05dbc1.png";